import React from "react";
import styles from "./PracticePortalWelcome.module.scss";
import Header from "../Header/header";
import { useNavigate } from "react-router-dom";

type Step = {
  no: number;
  title: string;
  body: string;
};


const STEPS: Step[] = [
  {
    no: 1,
    title: "Practice and personal info",
    body:
      "Help us get to know you and your practice. This info personalises your experience and communications.",
  },
  {
    no: 2,
    title: "Logo management",
    body:
      "Upload your practice logo to brand your portal and emails beautifully.",
  },
  {
    no: 3,
    title: "Social media links",
    body:
      "Add your social profiles to connect with patients and grow your online presence.",
  },
  {
    no: 4,
    title: "Add your portfolio",
    body:
      "Import treatment videos and gifs to visually explain procedures and build trust with your patients.",
  },
  {
    no: 5,
    title: "Staff management plan",
    body:
      "Add your team members and assign roles to keep your practice organised and efficient.",
  },
  {
    no: 6,
    title: "Consent template setup",
    body:
      "Create your base consent form this will be used to generate email templates for patient communication.",
  },
];

type Props = {
  onBegin?: () => void; 
};

export default function PracticePortalWelcome({ onBegin }: Props) {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <Header />

      <main className={styles.main}>
        <section className={styles.hero}>
          <h1 className={styles.title}>Welcome to your practice portal</h1>

          <p className={styles.subtitle}>
            Welcome to MediCube! You’re just a few steps away from making your
            portal truly yours. Add your practice details, logo, social links,
            and portfolio, then set up your team and consent templates. Once
            you’re done, you’ll be ready to send clear, professional treatment
            plans that help your patients feel informed and supported.
          </p>
     <button
      className={styles.beginBtn}
      type="button"
      onClick={() => navigate("/practiceDetails")}
      aria-label="Begin setup"
    >
      Lets begin setup
    </button>
        </section>

        <section className={styles.stepsSection} aria-label="Setup steps">
          <div className={styles.grid}>
            {STEPS.map((s) => (
              <article key={s.no} className={styles.card}>
                <div className={styles.badge} aria-hidden="true">
                  {s.no}
                </div>
                <h3 className={styles.cardTitle}>{s.title}</h3>
                <p className={styles.cardBody}>{s.body}</p>
              </article>
            ))}
          </div>
        </section>
      </main>

      <footer className={styles.footer}>
        Copyright © Medicube 2025. All Rights Reserved.
      </footer>
    </div>
  );
}
